class MegaMenuCollapsable extends HTMLElement {
  constructor() {
    super();
    const details = this.querySelector(".item");
    if (window.innerWidth < 700) {
      details.removeAttribute("open");
    }
    if (details) {
      window.innerWidth < 700 ? details.removeAttribute("open") : details.setAttribute("open", "");
    }
  }
}
if (customElements.get("mega-menu-collapsable") === void 0) {
  customElements.define("mega-menu-collapsable", MegaMenuCollapsable);
}
